/**
 * The `updated_at` for a change made to a stored copy of something: now, but never equal to or
 * earlier than the copy's previous stamp. Two changes within the same millisecond (or a device
 * clock a little behind the one that wrote the previous stamp) would otherwise leave the change
 * looking "not newer", and the merge sync (the newer `updated_at` wins) could then drop it.
 */
export function laterThan(previous: string | null | undefined, now: Date = new Date()): string {
  const stamp = now.getTime();
  const before = previous ? new Date(previous).getTime() : NaN;
  return new Date(Number.isFinite(before) && stamp <= before ? before + 1 : stamp).toISOString();
}
